export class EmailContactModel {
  public ContactID: number;
  public Email: string;

  constructor(init: any) {
    this.ContactID = init.ContactID;
    this.Email = init.Email;
  }
}
